import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { GenomicForm, MetricsForm } from "./ManualForms";
import { CsvUpload, PdfUpload } from "./UploadForms";

export function IntakeHub({ patient, onChanged }) {
  const [catalog, setCatalog] = useState(null);
  useEffect(() => { api.get("/patients/catalog").then((r) => setCatalog(r.data)); }, []);
  if (!catalog) return null;
  const trig = "rounded-full data-[state=active]:bg-teal-700 data-[state=active]:text-white";
  return (
    <div className="space-y-4" data-testid="data-intake-hub">
      <Tabs defaultValue="metrics">
        <TabsList className="bg-white border border-slate-200 rounded-full p-1 h-auto flex-wrap">
          <TabsTrigger data-testid="metrics-form-tab" value="metrics" className={trig}>Health metrics</TabsTrigger>
          <TabsTrigger data-testid="genomic-form-tab" value="genomic" className={trig}>Genomic markers</TabsTrigger>
          <TabsTrigger data-testid="pdf-upload-tab" value="pdf" className={trig}>PDF report</TabsTrigger>
          <TabsTrigger data-testid="csv-upload-tab" value="csv" className={trig}>CSV / lab file</TabsTrigger>
        </TabsList>
        <TabsContent value="metrics" className="mt-4"><MetricsForm patient={patient} catalog={catalog.metrics} onChanged={onChanged} /></TabsContent>
        <TabsContent value="genomic" className="mt-4"><GenomicForm patient={patient} catalog={catalog.genomic} onChanged={onChanged} /></TabsContent>
        <TabsContent value="pdf" className="mt-4"><PdfUpload patient={patient} onChanged={onChanged} /></TabsContent>
        <TabsContent value="csv" className="mt-4"><CsvUpload patient={patient} onChanged={onChanged} /></TabsContent>
      </Tabs>
    </div>
  );
}
